// The ONE place the ORG-015 (`invalid_email_format`) copy is written.
//
// Sibling of contract-notice.ts, and for the same reason: ONE backend rule is
// refused by TWO slices under one code (change_clinician_email and
// invite_clinician both raise 422 ORG-015 when an address parses as RFC 5322
// but not as the narrower sign-in grammar of
// `domain.authentication.value_objects.Email`). An org_admin typing the same
// address into Add Person and into the Change-email dialog is hitting a single
// rule, so it has to read the same on both surfaces — two hand-written copies
// of one sentence drift into two different explanations of one situation.
//
// It stays a separate module rather than joining contract-notice.ts: that file
// is about the org CONTRACT state (it takes a `ContractStatus`, formats the
// contract end date, and maps a status to a banner). This refusal is about an
// address the admin typed, and shares none of that machinery.
//
// [Source: src/application/organizations/_shared/exceptions.py — 422 ORG-015
//  invalid_email_format, raised by both change_clinician_email and
//  invite_clinician.]

/**
 * Named only where the refusal renders as a titled banner (the Edit-member
 * modal). The Add-person form attaches the body inline to `workEmail`, where a
 * field already labelled "Work email" makes a title redundant — so the title is
 * exported separately rather than baked into the body.
 */
export const INVALID_SIGN_IN_EMAIL_TITLE = "That email address can't be used to sign in";

/**
 * The refusal itself: what is wrong, and the rule the admin can act on. Stands
 * alone deliberately — it is the WHOLE message on the inline surface, so it
 * must never lean on the title above to make sense.
 */
export const INVALID_SIGN_IN_EMAIL_BODY =
  "The address is valid on paper but not as a sign-in address. Use letters, digits and . _ % + - before the @, then try again.";
